export const getFirstArrayElement = (arr) =>
  arr?.filter((x) => typeof x !== undefined).shift()
